import { IJobDTO } from 'src/api/dtos';
import http from 'src/api/http';
import ESSRepository from 'src/api/repositories/ess/ess.repository';
import { IListQueryResult } from 'src/api/types';

export default class JobRepository extends ESSRepository {
  private static readonly baseRoute = '/jobs';
  private static readonly apiURL = JobRepository.setBaseUrl(this.baseURL, this.baseRoute);

  public get = async (): Promise<IJobDTO[]> => {
    try {
      const { data } = await http.get<IListQueryResult<IJobDTO>>(JobRepository.apiURL);
      return data.items;
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
